import { Component, computed, effect, inject, OnInit, signal } from '@angular/core';
import { toSignal, toObservable } from '@angular/core/rxjs-interop';
import { PredictionService, RoiData } from '../../../../services/prediction.service';
import { SubscriptionPlansService } from '../../../../services/subscription-plans.service';
import { map, switchMap, of } from 'rxjs';

@Component({
  selector: 'app-stats-widget',
  templateUrl: './stats-widget.component.html',
  styleUrl: './stats-widget.component.scss',
  standalone: true,
})
export class StatsWidgetComponent implements OnInit {
  private predictionService = inject(PredictionService);
  private subscriptionPlan = inject(SubscriptionPlansService);
  private userId = JSON.parse(localStorage.getItem('user') || '{}').user_id;
  detailsLastPrediction: string | null = "";
  roiData = signal<RoiData | null>(null);
  viewedPredictions = toSignal(
    this.predictionService.getTotalViewedPredictions(this.userId),
    { initialValue: null }
  );


  predictionId = computed(() => {
    return this.viewedPredictions()?.last_prediction_id?.toString() ?? null;
  });

  predictionDetails = toSignal(
    toObservable(this.predictionId).pipe(
      switchMap(id => {
        if (id) {
          return this.predictionService.getPredictionDetails(id, this.userId);
        } else {
          return of(null); 
        }
      })
    ),
    { initialValue: "" }
  );

  ngOnInit() {
    this.loadRoiData(30);
  }

  subscriptionDaysLeft = toSignal(
    this.subscriptionPlan.getUserDaysLeft(this.userId).pipe(
      map(res => res.days_left)
    ),
    { initialValue: 0 }
  );
  detailsLastPredictions = computed(() => {
    if (this.viewedPredictions() && this.predictionDetails() && this.predictionDetails().length > 0) {
      const prediction = this.predictionDetails()[0];
      const sport = prediction.sport_name;
      let details;
      if (prediction.confidence_team_away > prediction.confidence_team_home) {
        details = `${prediction.team_away_name} ${prediction.confidence_team_away * 100}%`;
      } else {
        details = `${prediction.team_home_name} ${prediction.confidence_team_home * 100}%`;
      }
      return `${sport} : ${details}`;
    }
    return null;
  })



  private loadRoiData(periodDays: number) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user.user_id) return;



    this.predictionService.getCombinedRoi(user.user_id, periodDays).subscribe({
      next: (data) => {
        this.roiData.set(data);
      },
      error: (error) => {
        console.error('Erreur lors du chargement des données ROI:', error);
      }
    });
  }

  getAveragePlatformRoi(): number {
    const data = this.roiData();
    if (!data || data.platform_roi.length === 0) return 0;

    const sum = data.platform_roi.reduce((acc, val) => acc + val, 0);
    return Math.round((sum / data.platform_roi.length) * 100) / 100;
  }

}
